import ImageGalleryComponentSp from "../pages/ImageGalleryComponentSp";
import ImageGalleryComponentPc from "../pages/ImageGalleryComponentPc";
import QuestionnairePc from "../pages/QuestionnairePc";
import QuestionnaireSp from "../pages/QuestionnaireSp";
import NotFound from "../pages/NotFound";
import NotToday from "../pages/NotToday";
import ImageRegister from "../pages/ImageRegister";

import Home from "../pages/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<ImageRegister />} />
        <Route path="/questskiPc" element={<QuestionnairePc />} />
        <Route path="/questskiSp" element={<QuestionnaireSp />} />
        <Route path="/dlimagesPc" element={<ImageGalleryComponentPc />} />
        <Route path="/dlimagesSp" element={<ImageGalleryComponentSp />} />
        <Route path="/nottoday" element={<NotToday />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
